/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_PrevInputs */

const en_us2_today_prev = /** @type {(inputs: Today_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous exercises`)
};

const pt_br2_today_prev = /** @type {(inputs: Today_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercícios anteriores`)
};

const es_419_today_prev = /** @type {(inputs: Today_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejercicios anteriores`)
};

const pt_pt2_today_prev = /** @type {(inputs: Today_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercícios anteriores`)
};

const fr_fr2_today_prev = /** @type {(inputs: Today_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercices précédents`)
};

const de_de2_today_prev = /** @type {(inputs: Today_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorherige Übungen`)
};

const it_it2_today_prev = /** @type {(inputs: Today_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercizi precedenti`)
};

/**
* | output |
* | --- |
* | "Previous exercises" |
*
* @param {Today_PrevInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_prev = /** @type {((inputs?: Today_PrevInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_PrevInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_prev(inputs)
	if (locale === "es-419") return es_419_today_prev(inputs)
	if (locale === "pt-PT") return pt_pt2_today_prev(inputs)
	if (locale === "fr-FR") return fr_fr2_today_prev(inputs)
	if (locale === "de-DE") return de_de2_today_prev(inputs)
	if (locale === "it-IT") return it_it2_today_prev(inputs)
	return en_us2_today_prev(inputs)
});
export { today_prev as "today.prev" }